export default "__VITE_ASSET__a4Bl2ANd__"